/**
 * The feed renders MobileOfferCard below `lg` and HomeOfferCard from `lg` up.
 * The cards, the LazyHydration wrapper around the desktop card and the loading
 * skeletons all have to agree on that boundary — if they drift, an intermediate
 * breakpoint ends up showing both layouts or neither.
 *
 * Two desktop variants because the wrapper is a block and the card itself is a
 * flex container.
 */
export const FEED_MOBILE_ONLY = 'lg:hidden';

export const FEED_DESKTOP_ONLY_BLOCK = 'hidden lg:block';

export const FEED_DESKTOP_ONLY_FLEX = 'hidden lg:flex';
